import { render, staticRenderFns } from "./fallback-filter.vue?vue&type=template&id=75242646&"
import script from "./fallback-filter.vue?vue&type=script&lang=ts&"
export * from "./fallback-filter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports